<glxy-form-field class="opportunity-info__input" appearance="outline" [matMenuTriggerFor]="assigneeMenu">
  <glxy-label>{{ 'FRONTEND.SALES_UI.COMMON.ASSIGNEE' | translate }}</glxy-label>
  <input matInput [readonly]="true" [value]="assignee$ | async" />
  <mat-menu #assigneeMenu="matMenu">
    <div class="mat-menu__assignee-dropdown">
      <ng-container *ngFor="let salesperson of salespeople$ | async">
        <button mat-menu-item (click)="updateAssignee(salesperson)">
          {{ salesperson.fullName }}
        </button>
      </ng-container>
    </div>
  </mat-menu>
</glxy-form-field>
